import { Reveal } from "@/components/Motion";
import AINetwork from "@/components/AINetwork";

const STATS = [
  { k: "05", v: "Advanced Domains" },
  { k: "100%", v: "Hands On Labs" },
  { k: "AI", v: "Security Focused" },
];

const AboutBrand = () => {
  return (
    <section
      id="about-brand"
      data-testid="about-brand"
      className="relative py-28 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 grid lg:grid-cols-2 gap-14 lg:gap-20 items-center">
        <div>
          <Reveal>
            <span className="font-mono2 text-xs uppercase tracking-[0.3em] text-[#16fcfb]">
              [ 001 ] About Hacktonomy
            </span>
          </Reveal>
          <Reveal delay={0.05}>
            <h2 className="mt-6 font-display font-700 text-4xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-white">
              Setting the Benchmark for{" "}
              <span className="text-[#16fcfb] text-glow-cyan"> Cybersecurity Excellence </span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="mt-8 font-body text-lg text-[#97b8ff] leading-relaxed">
             Hacktonomy is an Indian certification platform focused on validating cybersecurity skills through practical, industry-relevant assessments and standards.
            </p>
          </Reveal>
          <Reveal delay={0.15}>
            <p className="mt-5 font-body text-base text-white/70 leading-relaxed">
              Our flagship certification, HCASP, equips security engineers and
              ML professionals with the offensive and defensive fluency the AI
              era demands.
            </p>
          </Reveal>

          <div className="mt-12 grid grid-cols-3 gap-4">
            {STATS.map((s, i) => (
              <Reveal key={s.v} delay={0.1 + i * 0.08}>
                <div className="border-l border-[#3d414f] pl-4">
                  <div className="font-display font-700 text-2xl md:text-3xl text-white">
                    {s.k}
                  </div>
                  <div className="mt-1 font-mono2 text-[10px] uppercase tracking-[0.15em] text-[#97b8ff]">
                    {s.v}
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
  
        <Reveal delay={0.1} className="relative">
          <AINetwork />
          <div className="absolute -z-10 -inset-4 rounded-3xl bg-[#4d4479]/20 blur-2xl" />
        </Reveal>
      </div>
    </section>
  );
};

export default AboutBrand;
